<span [class]="computedClasses">
  <ng-content></ng-content>
</span>

